export enum GerichtProfileLinkRel {
	EDIT = 'edit',
}
